/**
 * constants for Vote Buttons
 * @type {Object}
 */
module.exports = {
    TEN: 10,
    TWENTY: 20,
    THIRTY: 30,
    FORTY: 40
};



// WEBPACK FOOTER //
// ./app/scripts/constants/vote-buttons.js